import * as React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./utils/error-suppression";
import * as Sentry from "@sentry/react";
import { tracker } from "@/lib/tracking.ts";

tracker.init();

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<Sentry.ErrorBoundary
			fallback={
				<div style={{ padding: 16 }}>
					Something went wrong. Please refresh and try again.
				</div>
			}
		>
			<App />
		</Sentry.ErrorBoundary>
	</React.StrictMode>,
);
